export default {"src":"/_next/static/media/03_Gift_EN.eeb50d75.gif","height":261,"width":267};